import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ProtectingWhatMattersMost from "./sections/ProtectingWhatMattersMost";
import YourPersonalizedCoveragePlan from "./sections/YourPersonalizedCoveragePlan";
import WhyFamiliesTrustUs from "./sections/WhyFamiliesTrustUs";
import PeaceOfMindForOurClients from "./sections/PeaceOfMindForOurClients";
import CommonQuestions from "./sections/CommonQuestions";
import IndustryCredentials from "./sections/IndustryCredentials";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ProtectingWhatMattersMost />
      <YourPersonalizedCoveragePlan />
      <WhyFamiliesTrustUs />
      <PeaceOfMindForOurClients />
      <CommonQuestions />
      <IndustryCredentials />
      <Footer />
    </div>;
}